<router-outlet></router-outlet>

<p-blockUI [blocked]="service.blockUI" [baseZIndex]="999999">
  <div class="lds-facebook">
    <div></div>
    <div></div>
    <div></div>
  </div>
</p-blockUI>

<pdf-viewer></pdf-viewer>
